import {getCommodityList} from "./Service";

/**
 * 获取商品列表
 * @param payType 支付类型 1=支付宝 2=微信 3=网上银行 4=银行快捷支付 5=手机充值卡 6=游戏点卡 7=固话短信 8=新手充值卡
 * @param scene 场景  PC scene = "102,10000,10011"；phone scene = "10014,10015";
 * @constructor
 */
const GetItemList = async (payType, scene, callback) => {
    if (payType > 0 && scene != "") {
        const urlParms = {
            'pageIndex': 1,
            'pageSize': 200,
            'scene': scene,
            'payType': payType
        }
        getCommodityList(urlParms, true).then(ret => {
            callback(ret.data);
        }).catch(err => {
            console.log(err)
        });
    }
};

export {GetItemList};